package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.ui.runtime.element.ItemStack

/**
 * SNBT 序列化（JS actual）：物品渲染为占位语义（ADR-0068 §6），返回 null。
 */
internal actual fun staticItemSnbt(item: ItemStack): String? = null

/**
 * SNBT 反序列化（JS actual）：占位语义，返回 null。
 */
internal actual fun staticItemMapOf(snbt: String?): Map<String, Any>? = null
